var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('button',{staticClass:"prompt",on:{"click":_vm.openModal}},[_c('span',[_vm._v("Help us improve")]),_c('font-awesome-icon',{staticClass:"icon alt",attrs:{"icon":['fas', 'comment-lines']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }